export default __webpack_public_path__ + "static/media/velo.01aa9671.gif";